export const MAX_FILE_SIZE = 524288000;
export const MAX_FILE_SIZE_ERROR = 'File should be less then 500 MB'
export const MAX_AD_TIME = 30
export const BANNER_AD_TIME = 32
export const MAX_AD_ALLOWED = 5